import { Button, Modal } from "semantic-ui-react";
import { displayNetworkCodeOption, IParameter } from "../../models/parameter";
import { useCallback, useEffect, useState } from "react";
import { IParameterAnswer } from "../../models/parameterAnswer";
import { getSummaryAnswers } from "../../services/parameterAnswerService";
import { toast } from "../..";

interface IProps {
    modalOpen: boolean;
    closeModal: () => void;
    parameter: IParameter;
    selectedCountryName: string;
    parameterAnswer: string;
}

export const SummaryModal = ({
    modalOpen,
    closeModal,
    parameter,
    selectedCountryName,
    parameterAnswer,
}: IProps) => {
    const [parameterAnswers, setParameterAnswers] = useState<IParameterAnswer[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchSummaryAnswers = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getSummaryAnswers(parameter.guid, selectedCountryName);
            setParameterAnswers(res);
        } catch {
            toast("Error fetching parameter answers", false, 1000);
        }
        setLoading(false);
    }, [parameter, selectedCountryName]);

    useEffect(() => {
        if (modalOpen) {
            fetchSummaryAnswers();
        }
    }, [modalOpen, fetchSummaryAnswers]);

    return (
        <Modal
            className="summary-modal"
            open={modalOpen}
            onClose={() => closeModal()}
            size="small"
            closeOnDimmerClick={false}
            loading={loading}
        >
            <Modal.Header>
                <h2>
                    {parameterAnswers.length > 0 &&
                        `${parameterAnswers[0].countryName} - 
                ${displayNetworkCodeOption(parameter.networkCode)} summary`}
                </h2>
                <h3>{parameterAnswer}</h3>
            </Modal.Header>
            <Modal.Content>
                {parameterAnswers.length > 0 && (
                    <table className="summary-modal-table">
                        {parameterAnswers.map((answer, index) => (
                            <tr key={index} className="summary-answer-item">
                                <td>
                                    <b>{answer.parameterName}</b>
                                </td>
                                <td>
                                    <div
                                        className={`color-rectangle answer${
                                            answer.forcedAnswerValue ?? answer.answerValue
                                        }`}
                                    ></div>
                                </td>
                                <td>{answer.answerTitle}</td>
                                <td className="remark">{answer.remark}</td>
                            </tr>
                        ))}
                    </table>
                )}
            </Modal.Content>
            <Modal.Actions>
                <div className="basic-actions">
                    <Button onClick={() => closeModal()} content="Close" />
                </div>
            </Modal.Actions>
        </Modal>
    );
};
